import { Info } from "lucide-react";
import { formatIDR, formatDuration, mediaUrl } from "@/lib/api";

export function DetailCard({ t }) {
  const joined = t.created_at ? new Date(t.created_at).toLocaleDateString("id-ID", { month: "long", year: "numeric" }) : "-";
  return (
    <section className="ib-card" data-testid="talent-detail-card">
      <h2 className="ib-title">Detail Talent</h2>
      {t.has_video ? (
        <div className="mt-6 rounded-xl border border-[#E5E7EB] bg-black flex justify-center overflow-hidden" data-testid="talent-video-wrap">
          <video controls playsInline preload="metadata" poster={mediaUrl(t.avatar_url) || undefined} className="w-full max-h-[470px] bg-black" src={`${process.env.REACT_APP_BACKEND_URL}/api/talents/${t.id}/video?v=${t.video_version || 0}`} data-testid="talent-video">
            Browser kamu tidak mendukung pemutar video.
          </video>
        </div>
      ) : t.avatar_url && (
        <div className="mt-6 rounded-xl border border-[#E5E7EB] bg-[#F3F4F6] flex justify-center overflow-hidden" data-testid="talent-cover-wrap">
          <img src={mediaUrl(t.avatar_url)} alt={t.name} className="w-auto h-auto max-w-full max-h-72 sm:h-[470px] sm:max-h-none object-contain" data-testid="talent-cover" />
        </div>
      )}
      <dl className="mt-8 flex flex-wrap gap-x-6 gap-y-4 text-base">
        <div className="min-w-[180px]"><dt className="inline-flex items-center gap-2 font-semibold text-black">ID Talent <Info size={14} className="text-[#F79526]" strokeWidth={2} /></dt><dd className="mt-1 text-black" data-testid="talent-id">CK-T{t.id.slice(-6).toUpperCase()}</dd></div>
        <div className="min-w-[180px]"><dt className="inline-flex items-center gap-2 font-semibold text-black">Verifikasi <Info size={14} className="text-[#F79526]" strokeWidth={2} /></dt><dd className="mt-1 text-black">KTP & wawancara · bergabung {joined}</dd></div>
      </dl>
      <p className="mt-6 text-base leading-6 text-black" data-testid="talent-bio">{t.bio}</p>
    </section>
  );
}

export function EducationCard({ education = [] }) {
  return (
    <section className="ib-card" data-testid="talent-education-card">
      <h2 className="ib-title">Pengalaman & Pelatihan</h2>
      <div className="mt-5 space-y-5">
        {education.length ? education.map((e, i) => (
          <div key={i} data-testid="talent-education-item">
            <p className="font-semibold text-black">{e.title}</p>
            <p className="mt-0.5 text-[#626262]">{e.subtitle}</p>
          </div>
        )) : <p className="text-sm text-[#626262]">Belum diisi.</p>}
      </div>
    </section>
  );
}

export function PricingCard({ offered }) {
  return (
    <section className="ib-card" data-testid="talent-pricing-card">
      <h2 className="ib-title">Layanan & Harga</h2>
      <div className="mt-5 space-y-4">
        {offered.map((s) => (
          <div key={s.id} data-testid={`package-group-${s.id}`}>
            <p className="font-semibold text-black">{s.name}</p>
            <ul className="mt-1 space-y-1 text-[#626262]">
              {s.packages.map((p) => <li key={p.minutes} className="flex justify-between" data-testid={`package-${s.id}-${p.minutes}`}><span>{formatDuration(p.minutes)}</span><span className="font-medium text-black">{formatIDR(p.price)}</span></li>)}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export function TopicsCard({ skills }) {
  return (
    <section className="ib-card" data-testid="talent-topics-card">
      <h2 className="ib-title">Topik Keahlian</h2>
      <div className="mt-5 flex flex-wrap gap-2">
        {skills?.length ? skills.map((s) => <span key={s} className="ib-chip" data-testid="talent-skill">{s}</span>) : <p className="text-sm text-[#626262]">Belum diisi.</p>}
      </div>
    </section>
  );
}
